import {
  MenuSeparator as AriakitMenuSeparator,
  DialogDisclosure,
  Menu,
  MenuButton,
  MenuItem,
  type MenuItemProps,
  MenuProvider,
  type MenuStoreState,
} from "@ariakit/react";
import type { ReactElement, ReactNode } from "react";
import { Link } from "wouter";
import * as css from "./style.css.ts";

export function MoreMenu(props: {
  label?: string;
  children: ReactNode;
  iconColor?: string;
  className?: string;
  placement?: MenuStoreState["placement"];
  icon?: ReactElement;
}) {
  const { label = "Actions", placement } = props;

  return (
    <MenuProvider placement={placement ?? "top-end"}>
      <MenuButton className={props.className ?? css.menuButton}>
        {props.icon ?? (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill={props.iconColor ?? "#232424"}
            xmlns="http://www.w3.org/2000/svg"
          >
            <title>{label}</title>
            <circle cx="12" cy="20" r="2" />
            <circle cx="20" cy="20" r="2" />
            <circle cx="28" cy="20" r="2" />
          </svg>
        )}
      </MenuButton>

      <Menu className={css.menu}>{props.children}</Menu>
    </MenuProvider>
  );
}

export function MoreMenuItem(props: Omit<MenuItemProps, "className">) {
  return <MenuItem {...props} className={css.menuItem} />;
}

export function MenuLink(
  props: Omit<MenuItemProps, "className" | "render"> & { href: string }
) {
  return (
    <MenuItem
      {...props}
      className={css.menuItem}
      render={<Link href={props.href} />}
    />
  );
}

export function MenuDialogDisclosure(
  props: Omit<MenuItemProps, "className" | "render">
) {
  return (
    <MenuItem
      {...props}
      className={css.menuItem}
      render={<DialogDisclosure />}
    />
  );
}

export function MenuSeparator() {
  return <AriakitMenuSeparator className={css.menuSeparator} />;
}
